import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import peopleModel from './peopleModel.vue';
import iconModel from './iconModel.vue';
import editModel from './editModel.vue';
import NeweditModel from './NeweditModel.vue';
import { cryptoDecrypt } from '@/utils/aes';
import controlItem from './controlItem.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { uploadFile } from './../../customer/applicationManage/request';
import { editFlowNode, addFlowNode, cascadelist } from './request';
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
import emailModel from './emailModel.vue';
import newControlItem from './components/newControlItem.vue';
export default {
  components: {
    topTitle,
    peopleModel,
    iconModel,
    editModel,
    NeweditModel,
    controlItem,
    quillEditor,
    emailModel,
    newControlItem
  },
  props: ['num', 'dataFrom2', 'process', 'isEdit', 'maxNodeNum', 'itemid', 'bankData', 'provinceFirstLevel', 'logisticsData', 'provinceArea', 'provinceData', 'countriesData'],
  data() {
    return {
      // 获取新建数据
      tabulateList: [],
      action: uploadFile,
      dataFrom: null,
      peopleShow: false,
      iconShow: false,
      editShow: false,
      editShow2: false,
      oldBtnObj: {
        name: '',
        color: 'primary',
        goBack: '2',
        node: ''
      },
      btnObj: {
        index: 1,
        name: '',
        color: 'primary',
        goBack: '',
        node: '',
        fileList: [],
        fileEmptyTipMessage: '请上传文件模板'
      },
      fileList: [],
      flowList: [],
      quillOption: quillConfig,
      typeList: [{
        name: '保险公司',
        value: '1'
      }, {
        name: '中介公司',
        value: '2'
      }, {
        name: '普通客户',
        value: '0'
      }],
      colorList: [{
        name: '红色',
        value: 'danger'
      }, {
        name: '蓝色',
        value: 'primary'
      }, {
        name: '橘色',
        value: 'edit'
      }, {
        name: '绿色',
        value: 'add'
      }, {
        name: '紫色',
        value: 'copy'
      }],
      nodeList: [{
        name: '上一节点',
        value: 'UP_NODE'
      },
      // {name: '下一节点', value: 'NEXT_NODE'},
      {
        name: '指定节点',
        value: 'DESIGNATE_NODE'
      }, {
        name: '结束审核流（审核成功时）',
        value: 'END_NODE_SUCCESS'
      }, {
        name: '结束审核流（审核失败时）',
        value: 'END_NODE_FAIL'
      }, {
        name: '初始节点',
        value: 'INITIAL_NODE'
      }, {
        name: '预览文件',
        value: 'PREVIEW_FILE'
      }],
      firstNodelist: [{
        name: '预览文件',
        value: 'PREVIEW_FILE'
      }, {
        name: '指定节点',
        value: 'DESIGNATE_NODE'
      }, {
        name: '结束审核流（审核成功时）',
        value: 'END_NODE_SUCCESS'
      }],
      echoList: [{
        id: 0,
        step: 0
      }],
      selectEchoNodeList: [],
      customerTagValidateObj: {
        validateStatus: 'success',
        help: ''
      },
      sendEmailPartShow: false,
      recipientEmail: '',
      addEmailType: '',
      notifyObj: {
        type: '',
        recipient: [],
        is_cc: false,
        cc: [],
        bcc: [],
        is_bcc: false,
        title: '',
        content: '',
        fileTemplate: [],
        operate: {
          userConfirm: '',
          triggerWhere: '',
          value: []
        }
      },
      addEmailVisible: false,
      addEmailTitle: '',
      loading: false,
      editIndex: -1
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('节点名称')
        }, {
          min: 1,
          max: 100,
          message: this.$t('节点名称最多支持输入100字符'),
          trigger: 'blur'
        }],
        reviewer: [{
          required: true,
          trigger: 'change',
          validator: this.validateReviewer
        }],
        method: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('审核方式')
        }],
        sharedPrevNode: [{
          required: true,
          trigger: 'blur',
          validator: this.validateSharedType
        }],
        // sharedNode: [{required: true, trigger: 'blur', message: '请输入回显内容'}],
        actionButton: [{
          required: true,
          trigger: 'blur',
          validator: this.validateButton
        }]
      };
    },
    disabledCustomTag() {
      //在填写了文案内容和图标的情况下，才能选择客户标签
      return !this.dataFrom.isEdit || !this.dataFrom.copywriting || !this.dataFrom.copywritingIconName;
    },
    showEditCheckBox() {
      //回显节点 在多个人会签的时候不能编辑
      return !(this.dataFrom.method === 'COUNTERSIGN' && this.dataFrom.reviewer.length > 1);
    },
    allActionButton() {
      return this.dataFrom.actionButton.filter(item => item.name);
    },
    allFileTemplate() {
      let fileList = [];
      this.dataFrom.actionButton.forEach(item => {
        if (item.goBack === 'PREVIEW_FILE') {
          fileList = fileList.concat(item.fileList);
        }
      });
      return fileList;
    }
  },
  watch: {
    'dataFrom.sharedNode': {
      handler(newVal) {
        let selectNode = this.echoList.filter(item => newVal.indexOf(item.step) != -1);
        let selectArr = [];
        selectNode.forEach(item => {
          let isEdit = false;
          this.selectEchoNodeList.forEach(item2 => {
            if (item2.step == item.step) {
              isEdit = item2.isEdit;
            }
          });
          let obj = {
            step: item.step,
            isEdit
          };
          selectArr.push(obj);
        });
        this.selectEchoNodeList = selectArr;
      },
      deep: true
    },
    dataFrom2(newVal, oldVal) {
      console.log(889625, newVal, oldVal);
    },
    isEdit() {
      console.log(this.isEdit, 'this.isEdit');
      this.dataFrom.isEdit = this.isEdit;
    }
  },
  created() {
    // this.getOptions();
  },
  mounted() {
    for (let i = 0; i < this.num - 1; i++) {
      this.echoList.push({
        id: i + 1,
        step: i + 1
      });
    }
    if (this.dataFrom2.id != -1) {
      this.infoFun();
    } else {
      this.dataFrom = this.dataFrom2;
    }
  },
  methods: {
    // 获取新建列表数据
    tabulateData(data) {
      this.tabulateList = data;
      console.log('获取新建list数据', data);
    },
    validateButton(rule, value, callback) {
      let isAll = true;
      let exceedMaxNode = false;
      this.dataFrom.actionButton.map(item => {
        if (!item.name || item.goBack == 'DESIGNATE_NODE' && !item.node) {
          isAll = false;
        }
        if (item.goBack == 'DESIGNATE_NODE' && Number(item.node) > this.maxNodeNum) {
          exceedMaxNode = true;
        }
        // if (item.goBack === 'PREVIEW_FILE' && item.fileList.length === 0) {
        //   callback(new Error(''));
        // }
      });
      if (!isAll) {
        callback(new Error(this.$t('请完善操作按钮')));
      } else if (exceedMaxNode) {
        callback(new Error(this.$t('指定节点不存在')));
      } else {
        callback();
      }
    },
    validateReviewer(rule, value, callback) {
      if (this.dataFrom.isSponsor) {
        callback();
      } else {
        if (this.dataFrom.reviewer.length != 0) {
          callback();
        } else {
          callback(new Error(this.$t('请选择') + this.$t('审核人')));
        }
      }
    },
    validateSharedType(rule, value, callback) {
      console.log(this.dataFrom.sharedPrevNode, 'this.dataFrom.sharedPrevNode');
      // if (!this.dataFrom.sharedPrevNode && this.num == 1) {
      //   callback(new Error(this.$t('请选择') + this.$t('回显内容节点')));
      // } else if (!this.dataFrom.sharedPrevNode && this.dataFrom.sharedNode.length == 0) {
      //   callback(new Error(this.$t('请选择') + this.$t('回显内容节点')));
      // } else {
      //   callback();
      // }
      if (this.dataFrom.sharedNode.length == 0) {
        callback(new Error(this.$t('请选择') + this.$t('回显内容节点')));
      } else {
        callback();
      }
    },
    infoFun() {
      this.dataFrom = recursionCopy(this.dataFrom2);
      if (this.dataFrom2.flowScheduleId == 0) {
        this.dataFrom.flowScheduleId = undefined;
      }
      this.processingFun();
    },
    processingFun() {
      if (this.dataFrom2.id == -1) {
        return false;
      }
      this.dataFrom.auditFlowNodeId = this.dataFrom2.id;
      let actionButtons = JSON.parse(this.dataFrom2.actionButton);
      this.dataFrom.actionButton = actionButtons.map(item => {
        item.fileList = item.fileTemplate.map((item2, index) => {
          return {
            name: item2.name,
            url: item2.url,
            uid: index + 1,
            status: 'done'
          };
        });
        return item;
      });
      this.selectEchoNodeList = JSON.parse(this.dataFrom2.sharedNode);
      let sharedNode = [];
      this.selectEchoNodeList.forEach(item => {
        sharedNode.push(item.step);
      });
      this.dataFrom.sharedNode = sharedNode;
      this.dataFrom.customerTag = this.dataFrom2.customerTag ? this.dataFrom2.customerTag.split(',') : [];
      // this.dataFrom.editableArea = this.dataFrom2.editableArea ? JSON.parse(this.dataFrom2.editableArea) : [];
      let editableArea = this.dataFrom2.editableArea ? JSON.parse(this.dataFrom2.editableArea) : [];
      console.log(this.editableArea, 'this.editableArea');
      this.echoFormData(editableArea);
      console.log(editableArea, 'editableArea');

      //设置消息通知回显
      let notifyArr = JSON.parse(this.dataFrom2.notify || '[]');
      if (notifyArr.length === 0) return;
      let notify = notifyArr[0];
      notify.recipient = notify.recipient ? notify.recipient.split(',') : [];
      notify.cc = notify.cc ? notify.cc.split(',') : [];
      notify.bcc = notify.bcc ? notify.bcc.split(',') : [];
      let fileTemplate = [];
      notify.fileTemplate && Array.isArray(notify.fileTemplate) && notify.fileTemplate.forEach(item => {
        fileTemplate.push(item.url);
      });
      notify.fileTemplate = fileTemplate;
      notify.operate.value = notify.operate.value ? notify.operate.value.split(',') : [];
      this.notifyObj = recursionCopy(notify);
    },
    async handleControlEcho(controlItem) {
      controlItem.isSelectedShow = false;
      controlItem.isSelected = false;
      controlItem.editing = false;
      controlItem.isCheck = false;
      console.log(controlItem, 'controlItem.control');
      let partsType = controlItem.partsType;
      if (partsType === 'singleLine') {
        let numberLimitArr = controlItem.numberLimit.split(',');
        if (controlItem.attributeVerification === 'NUMBER') {
          controlItem.numberMaxValue = numberLimitArr.length > 1 ? numberLimitArr[1] : undefined;
          controlItem.numberMinValue = numberLimitArr.length > 0 ? numberLimitArr[0] : undefined;
        } else {
          controlItem.textMinLength = numberLimitArr.length > 0 ? numberLimitArr[0] : undefined;
          controlItem.textMaxLength = numberLimitArr.length > 1 ? numberLimitArr[1] : undefined;
        }
      } else if (partsType === 'dropDown') {
        controlItem.selectedValues = [];
        let type = controlItem.type.type;
        if (type === 'provinceArea') {
          controlItem.Customvalues = this.provinceArea;
        } else if (type === 'province') {
          controlItem.Customvalues = this.provinceData;
        } else if (type === 'provinceFirstLevel') {
          controlItem.Customvalues = this.provinceFirstLevel;
        } else if (type === 'country') {
          controlItem.Customvalues = this.countriesData;
        } else if (type === 'bank') {
          controlItem.Customvalues = this.bankData;
        } else if (type === 'logistics') {
          controlItem.Customvalues = this.logisticsData;
        } else if (type === 'custom') {
          // let params = {
          //   type: 'CUSTOM',
          //   controlMark: controlItem.mark,
          //   is_hierarchy: false
          // };
          // controlItem.Customvalues = await cascadelist(params);
          controlItem.Customvalues = controlItem.dataList;
        }
      } else if (partsType === 'multiline') {
        let numberLimitArr = controlItem.numberLimit.split(',');
        controlItem.minWordCount = numberLimitArr.length > 0 ? numberLimitArr[0] : undefined;
        controlItem.maxWordCount = numberLimitArr.length > 1 ? numberLimitArr[1] : undefined;
      } else if (partsType === 'multipleChoice') {
        controlItem.selectedOptionsDX = [];
        let numberLimitArr = controlItem.numberLimit.split(',');
        controlItem.numberLimit1 = numberLimitArr.length > 0 ? numberLimitArr[0] : undefined;
        controlItem.numberLimit2 = numberLimitArr.length > 1 ? numberLimitArr[1] : undefined;
      } else if (partsType === 'singleChoice') {
        controlItem.selectedOption = '';
      } else if (partsType === 'enclosure') {
        console.log(controlItem, 'controlItem.control');
        // controlItem.fileSizeUnit = controlItem.fileSize;
        // controlItem.fileListData = controlItem.templateUrl;
        // controlItem.templateUrl = controlItem.templateUrl.join(',');
        controlItem.templateUrl = controlItem.templateUrl;
        controlItem.fileListData = controlItem.fileListData;
      }
    },
    async echoFormData(editableArea) {
      //编辑表单区回显
      this.customRequest = [];
      for (let item of editableArea) {
        console.log(item, '------');
        for (let controlItem of item.form) {
          if (controlItem.controlType === 'control') {
            this.handleControlEcho(controlItem.control);
          } else if (controlItem.controlType === 'controlGroup') {
            console.log(controlItem.control, controlItem, 'controlItem.control');
            for (let groupControl of controlItem.control) {
              this.handleControlEcho(groupControl);
            }
          }
        }
      }
      console.log('outFor');
      this.dataFrom.editableArea = JSON.parse(JSON.stringify(editableArea));
    },
    addpeopleFun(type, arr) {
      if (this.dataFrom.isSponsor) {
        return;
      }
      this.peopleShow = true;
      this.$nextTick(() => {
        this.$refs.peopleFrom.init(type, arr);
      });
    },
    addiconFun() {
      this.iconShow = true;
      this.$nextTick(() => {
        this.$refs.iconFrom.init();
      });
    },
    editFun2(arr) {
      this.editShow2 = true;
      this.$nextTick(() => {
        this.$refs.editFrom.init(arr);
      });
    },
    editFun3(arr) {
      this.editShow3 = true;
      this.$nextTick(() => {
        this.$refs.editFrom.init(arr);
      });
    },
    editForm(item, index) {
      console.log(item, 'item');
      this.editShow2 = true;
      this.editFormInfo = {
        name: item.formName,
        index: index
      };
      this.editIndex = index;
      this.$nextTick(() => {
        this.$refs.editFrom.init(item);
      });
    },
    editFun(arr) {
      this.editShow = true;
      this.$nextTick(() => {
        this.$refs.editFrom.init(arr);
      });
    },
    controlOk(obj) {
      var _this$editFormInfo;
      if ((_this$editFormInfo = this.editFormInfo) !== null && _this$editFormInfo !== void 0 && _this$editFormInfo.name) {
        let editIndex = this.editFormInfo.index;
        this.dataFrom.editableArea[editIndex] = obj;
        this.editFormInfo = null;
      } else if (Object.keys(obj).length > 0) {
        this.dataFrom.editableArea.push(obj);
      }
      // this.dataFrom.editableArea = arr;
    },
    addButton() {
      const val = recursionCopy(this.dataFrom.actionButton[this.dataFrom.actionButton.length - 1]);
      if (!val.name || val.goBack == 'DESIGNATE_NODE' && !val.node) {
        this.$message.destroy();
        return this.$message.error(this.$t('请完善按钮信息再添加') + '!');
      } else if (val.goBack == 'DESIGNATE_NODE' && Number(val.node) > this.maxNodeNum) {
        this.$message.destroy();
        return this.$message.error(this.$t('指定节点不存在') + '!');
      } else if (this.dataFrom.actionButton.length == 5) {
        this.$message.destroy();
        return this.$message.error(this.$t('最多添加五个') + '!');
      }
      // this.btnObj.index++;
      const obj = recursionCopy(this.btnObj);
      obj.index = this.dataFrom.actionButton.length + 1;
      this.dataFrom.actionButton.push(obj);
    },
    iconOk(name) {
      this.dataFrom.copywritingIconName = name;
    },
    peopleOk(type, arr) {
      if (type == 1) {
        this.dataFrom.reviewer = arr;
        if (this.dataFrom.reviewer.length > 1 && this.dataFrom.method == 'COUNTERSIGN') {
          this.selectEchoNodeList.forEach(item => {
            item.isEdit = false;
          });
        }
        this.$refs.dataFrom.clearValidate('reviewer');
      } else {
        this.dataFrom.cc = arr;
      }
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          var _this$dataFrom$custom;
          if (!this.disabledCustomTag && ((_this$dataFrom$custom = this.dataFrom.customerTag) === null || _this$dataFrom$custom === void 0 ? void 0 : _this$dataFrom$custom.length) === 0) {
            this.customerTagValidateObj.validateStatus = 'error';
            this.customerTagValidateObj.help = this.$t('请选择') + this.$t('客户标签');
            return;
          }
          let parameter = recursionCopy(this.dataFrom);
          console.log('获取-this.dataFrom-保存', this.dataFrom);
          delete parameter.isEdit;
          let actionButtons = [];
          let hasEmptyFile = false;
          let editableArea = JSON.parse(JSON.stringify(parameter.editableArea));
          console.log(editableArea, 'submit--点击保存');
          editableArea.forEach(item => {
            item.form.forEach(controlItem => {
              console.log(controlItem, 'controlItem');
              if (controlItem.controlType === 'controlGroup') {
                controlItem.control = controlItem.control.map(controlGroupItem => {
                  controlGroupItem = this.formatControlData(controlGroupItem);
                  // console.log(obj, 'obj');
                  // debugger;
                  return controlGroupItem;
                });
              } else {
                controlItem.control = this.formatControlData(controlItem.control);
              }
            });
          });
          console.log(editableArea, 'editableArea');
          parameter.actionButton.forEach((item, index) => {
            console.log(item, item.fileList, 'item');
            if (item.goBack === 'PREVIEW_FILE' && item.fileList.length === 0) {
              hasEmptyFile = true;
              this.$set(this.dataFrom.actionButton[0], 'fileEmptyTipMessage', '请上传文件');
            }
          });
          if (hasEmptyFile) return;
          parameter.actionButton.forEach(item => {
            let {
              index,
              name,
              goBack,
              color,
              fileList,
              node
            } = item;
            let obj = {
              color,
              index,
              name,
              goBack,
              node,
              fileTemplate: []
            };
            if (Array.isArray(fileList) && fileList.length > 0) {
              obj.fileTemplate = fileList.map(item => {
                return {
                  name: item.name,
                  url: item.url
                };
              });
            }
            actionButtons.push(obj);
          });
          parameter.actionButton = JSON.stringify(actionButtons);
          if (parameter.cc.length != 0) {
            let arr = [];
            parameter.cc.map(item => {
              arr.push({
                userId: item.id || item.userId,
                isSms: item.isSms || 0
              });
            });
            parameter.cc = JSON.stringify(arr);
          } else {
            parameter.cc = '';
          }
          if (parameter.reviewer.length != 0) {
            let arr = [];
            parameter.reviewer.map(item => {
              arr.push({
                userId: item.id || item.userId,
                isSms: item.isSms || 0
              });
            });
            parameter.reviewer = JSON.stringify(arr);
          } else {
            parameter.reviewer = '';
          }
          if (parameter.editableArea.length != 0) {
            parameter.editableArea = JSON.stringify(editableArea);
          } else {
            parameter.editableArea = '';
          }
          parameter.customerTag = parameter.customerTag.join(',');
          let sharedNode = [];
          this.selectEchoNodeList.forEach(item => {
            let obj = {
              step: item.step,
              isEdit: item.isEdit
            };
            sharedNode.push(obj);
          });
          // parameter.sharedNode = parameter.sharedNode.join(',');
          parameter.sharedNode = JSON.stringify(sharedNode);
          if (parameter.id == -1) {
            delete parameter.id;
          }
          if (this.notifyObj.type === 'EMAIL') {
            parameter.notify = this.formatNotifyData();
          } else {
            parameter.notify = JSON.stringify([]);
          }
          let fun = parameter.auditFlowNodeId ? editFlowNode : addFlowNode;
          // return;
          this.loading = true;
          fun(parameter).then(res => {
            this.loading = false;
            this.dataFrom.isEdit = false;
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok', res);
          }).catch(e => {
            this.loading = false;
          });
        }
      });
    },
    formatControlData(config) {
      let obj = {
        partsType: config.partsType,
        controlName: config.controlName,
        promptText: config.promptText,
        controlExplain: config.controlExplain,
        value: config.value,
        is_tag: config.is_tag || false,
        association: config.association,
        widthSet: config.widthSet,
        mark: config.mark,
        is_show: config.is_show,
        isRequired: config.isRequired
      };
      if (config.partsType === 'singleLine') {
        if (config.statistical === 'amount') {
          obj.statistical = config.statistical;
        }
        obj.prefix = config.prefix;
        obj.suffix = config.suffix;
        obj.attributeVerification = config.attributeVerification;
        obj.decimalPlaces = config.decimalPlaces;
        obj.statistical = config.statistical;
        if (controlItem.attributeVerification === 'NUMBER') {
          obj.numberLimit = config.numberMinValue + ', ' + config.numberMaxValue;
        } else {
          obj.numberLimit = config.textMinLength + ', ' + config.textMaxLength;
        }
      } else if (config.partsType === 'dropDown') {
        obj.type = config.type;
        obj.isMultipleChoice = config.isMultipleChoice;
      } else if (config.partsType === 'multiline') {
        obj.numberLimit = config.minWordCount + ',' + config.maxWordCount;
      } else if (config.partsType === 'enclosure') {
        console.log(config, '---------fujian----------');
        obj.fileFormat = config.fileFormat;
        obj.fileSize = config.fileSize;
        obj.fileNumber = config.fileNumber;
        // obj.templateUrl = config.templateUrl?.split(',');
        obj.templateUrl = config.templateUrl;
        obj.fileListData = config.fileListData;
      } else if (config.partsType === 'singleChoice') {
        obj.sortWay = config.sortWay;
        obj.macroStyle = config.macroStyle;
        obj.controlValue = config.controlValue;
      } else if (config.partsType === 'multipleChoice') {
        obj.sortWay = config.sortWay;
        obj.macroStyle = config.macroStyle;
        obj.controlValue = config.controlValue;
        obj.numberLimit = config.numberLimit1 + ',' + config.numberLimit2;
      } else if (config.partsType === 'date') {
        obj.dateType = config.dateType;
        obj.dateStart = config.dateStart;
        obj.dateEnd = config.dateEnd;
      } else if (config.partsType === 'paragraph') {
        obj.content = config.content;
      } else if (config.partsType === 'sign') {
        obj.url = config.url;
      } else if (config.partsType === 'table') {
        obj.containerTemplateId = config.containerTemplateId;
        obj.containerTemplateInfo = '';
      }
      console.log(obj, 'obj');
      return obj;
    },
    formatNotifyData() {
      let notify = [];
      let fileList = [];
      this.allFileTemplate.forEach(item => {
        if (this.notifyObj.fileTemplate.indexOf(item.url) != -1) {
          fileList.push({
            name: item.name,
            url: item.url
          });
        }
      });
      let obj = {
        type: this.notifyObj.type,
        recipient: this.notifyObj.recipient.join(','),
        is_cc: this.notifyObj.is_cc,
        cc: this.notifyObj.cc.join(','),
        is_bcc: this.notifyObj.is_bcc,
        bcc: this.notifyObj.bcc.join(','),
        title: this.notifyObj.title,
        content: this.notifyObj.content,
        fileTemplate: fileList,
        operate: {
          userConfirm: this.notifyObj.operate.userConfirm,
          triggerWhere: this.notifyObj.operate.triggerWhere,
          value: this.notifyObj.operate.value.join(',')
        }
      };
      notify.push(obj);
      return JSON.stringify(notify);
    },
    delBouttomFun(index) {
      this.dataFrom.actionButton.splice(index, 1);
      this.clearTriggerButton();
      this.clearFileTemplate();
    },
    onEdit() {
      this.$emit('editOk', this.num);
    },
    handleClose(removedTag, type) {
      const arr = type == 1 ? this.dataFrom.reviewer : this.dataFrom.cc;
      const tags = arr.filter(tag => tag.userId !== removedTag.userId);
      if (type == 1) {
        this.dataFrom.reviewer = tags;
      } else {
        this.dataFrom.cc = tags;
      }
    },
    launchChange(e) {
      if (e.target.checked) {
        this.dataFrom.reviewer = [];
        this.dataFrom.cc = [];
      }
      this.dataFrom.isSponsor = e.target.checked;
      // console.log(`checked = ${e.target.checked}`);
    },
    isSponsorCheckedFun(val) {
      return val ? true : false;
    },
    sharedTypeChange() {
      this.dataFrom.sharedNode = [];
    },
    echoNodeCheckChange(e, item, index) {
      this.$set(item, 'isEdit', e.target.checked);
    },
    // sharedPrevNodeChange(e) {
    //   this.dataFrom.sharedPrevNode = e.target.checked;
    // },
    deleteIcon() {
      this.dataFrom.copywritingIconName = '';
    },
    handleChange(info, item) {
      var _info$file;
      this.clearFileTemplate();
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.destroy();
          this.$message.error(info.file.response.message);
          this.fileList[this.fileList.length - 1].status = 'error';
        }
      }
      const wordReg = /(docx|doc)$/;
      const filename = (info === null || info === void 0 || (_info$file = info.file) === null || _info$file === void 0 ? void 0 : _info$file.name) || '';
      const imgSuffix = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
      const isWord = wordReg.test(imgSuffix);
      if (!isWord) {
        this.$message.destroy();
        this.$message.error(this.$t('请上传格式为.doc/.docx的文件'));
        return;
      }
      let fileList = info.fileList;
      console.log(fileList, 'fileList');
      if (fileList.length === 0) {
        item.fileEmptyTipMessage = '请上传文件';
      } else {
        item.fileEmptyTipMessage = '';
      }
      item.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
    },
    addEmail(key) {
      this.addEmailType = key;
      let titleMap = {
        recipient: this.$t('收件人邮箱'),
        is_cc: this.$t('抄送人邮箱'),
        is_bcc: this.$t('密送人邮箱')
      };
      this.addEmailTitle = titleMap[key];
      this.addEmailVisible = true;
    },
    cancelAddEmail(emails) {
      if (emails && Array.isArray(emails) && emails.length > 0) {
        this.notifyObj[this.addEmailType] = this.notifyObj[this.addEmailType].concat(emails);
      }
      this.addEmailType = '';
      this.addEmailTitle = '';
      this.addEmailVisible = false;
    },
    onCheckChange(e, key) {
      this.notifyObj[key] = e.target.checked;
    },
    settingEmail() {},
    deleteEmail(type, index) {
      this.notifyObj[type].splice(index, 1);
    },
    clearTriggerButton() {
      if (this.notifyObj.type === 'EMAIL') {
        this.notifyObj.operate.value = [];
      }
    },
    clearFileTemplate() {
      if (this.notifyObj.type === 'EMAIL') {
        this.notifyObj.fileTemplate = [];
      }
    },
    gobackChange(item) {
      item.node = '';
      this.clearTriggerButton();
    },
    previewFile(file) {
      // console.log(file,'--------预览---------')
      // const url = 'https://view.officeapps.live.com/op/view.aspx?src=' + file.url;
      // window.open(url);
    },
    cancelOk() {
      this.editIndex = -1;
      this.editShow2 = false;
      this.editFormInfo = null;
    },
    triggerWhereChange() {
      this.notifyObj.operate.value = [];
    }
  }
};